<template>
  <VueFinalModal class="modal"
                 content-class="modal-content"
                 content-transition="vfm-fade"
                 overlay-transition="vfm-fade">
    <form @submit="$event.preventDefault();$emit('ok')">
      <div class="modal-header">
        <h2>{{ title }}</h2>
        <font-awesome-icon class="close-icon" icon="fa-solid fa-xmark" title="Закрыть"
                           @click="$emit('close')"/>
      </div>
      <div class="modal-body">
        <slot></slot>
      </div>
      <div class="modal-footer">
        <button type="button" @click="$emit('close')">Отмена</button>
        <button type="submit" class="btn-success">ОК</button>
      </div>
    </form>
  </VueFinalModal>
</template>

<script>

import {VueFinalModal} from "vue-final-modal";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

export default {
  name: "UkiModal",
  components: {FontAwesomeIcon, VueFinalModal},
  props: ["title"],
  emits: ["close", "ok"],
  methods:{
    okClicked: function(event){
      console.log(event)
    }
  }
}
</script>

<style>
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  display: flex;
  flex-direction: column;
  border-radius: 6px;
  min-width: 400px;
  border: 1px solid #555;
  background-color: #333;
  justify-content: space-between;
  align-items: normal;
}

.modal-header {
  display: flex;
  padding: 12px;
  border-bottom: 1px solid #444;
  justify-content: space-between;
}

.modal-header .close-icon {
  cursor: pointer;
  color: #505050;
  font-size: 20px;
  margin-left: 12px;
}

.modal-header .close-icon:hover {
  color: var(--text-white);
}

.modal-body {
  padding: 12px;
}

.modal-footer {
  display: flex;
  justify-content: right;
  padding: 12px;
  border-top: 1px solid #444;
}

.modal-footer button:not(:last-child) {
  margin-right: 8px;
}

.modal-header h2 {
  font-size: 24px;
  font-weight: bold;
}
</style>